import script from "./DSTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DSTable.vue?vue&type=script&setup=true&lang=ts"

import "./DSTable.vue?vue&type=style&index=0&id=09194c2b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09194c2b"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QBtn});
